import * as React from "react"


const Close = ({className}: {className?: string}) => {
    return  <svg
    className={className}
    width="40"
    height="40"
    viewBox="0 0 11.49852 11.49852"
    version="1.1"
    id="svg5"
    xmlns="http://www.w3.org/2000/svg"><defs
      id="defs2" /><path
      id="rect37767-76"
      d="M 1.520327,1.0618597e-5 7.010419e-6,1.5203306 4.229197,5.7490106 7.010419e-6,9.9782106 1.520327,11.498531 l 4.2292,-4.2292004 4.22868,4.2292004 1.52032,-1.5203204 -4.22868,-4.2292 4.22868,-4.22869 L 9.978207,6.1859708e-7 5.749527,4.2286906 Z" /></svg>
 
 
}

export default Close